import moment from 'moment';
import 'moment/locale/zh-cn';
import httpManager from '../../util/common'
import Cookies from 'js-cookie'
import newsTypeLists from '../../../static/json/news_labels.json'
import { timestampToDate, dealNewsTypeLists } from '../../util/util'
import _ from 'lodash'
export default {
  data () {
    return {
      loading: false,
      newsType: 'A',
      companyName: undefined,
      oaid: '',
      date: [moment().subtract(6, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      companyNameList: [],
      newsList: [],
      form: this.$form.createForm(this, { name: 'publicSentiment' }),
      page: {
        pagenum: 1,
        pagesize: 10,
        total: 0,
        pagerCount:3,
        perfect: true,
      },
      follow_entity: false
    }
  },
  computed: {
    locale () {
      return Cookies.get('locale') || 'zh'
    },
    newsTypeOptions() {
      let typeOption = [
          {
            "title": "全部新闻",
            "value":"A",
            "key":"A"
          }
        ]
      const len = newsTypeLists[this.locale].length
      for (let i = 0; i < len; i++) {
        if (newsTypeLists[this.locale][i].value !== 'B') {
          typeOption.push(newsTypeLists[this.locale][i])
        }
      }
      return typeOption
    },

  },
  mounted () {
    this.getData()
  },
  methods: {
    getCompanyNameList: _.debounce(function (value) {
      const params = new Map()
      const self = this
      self.companyNameList = []
      params.set('keyword', value)
      httpManager('entity_fix', params)
        .then(res => {
          res.data.forEach(item => {
            item.label = item.full_short_ent_ticker
            item.value = item.id
            item.id = item.oa_id
          });
         self.companyNameList = res.data
        })
        .catch(error => {
          console.log(error)
        })
    }, 1000),
    getData () {
      this.loading = true
      this.newsList = []
      this.page.total = 0
      let params = new Map()
      const { newsType, companyName, date, oaid } = this
      const newdTypeStr = dealNewsTypeLists(newsType)
      params.set('news_type', newdTypeStr)
      if (companyName && companyName !== undefined) {
        params.set('oaid', companyName)
      }
      if (date[0] && date[0] !== undefined) {
        params.set('start_date', date[0])
        params.set('end_date', date[1])
      }
      params.set('content', true)
      params.set('pagenum', this.page.pagenum)
      params.set('pagesize', this.page.pagesize)
      params.set('follow_entity', this.follow_entity)
      httpManager('esg_news', params)
        .then(res => {
          const { data } = res.data
          if (Object.prototype.toString.call(data).substring(8, 14) === 'Object') {
            this.page.total = res.data.page.total
            this.loading = false
            return
          }
          data.forEach(item  => {
            item.time = timestampToDate(item.ctime, true)
            if (item.company_info) {
              item.company = ''
              item.company_info.forEach((ele, index) => {
                if (index !== item.company_info.length - 1) {
                  item.company += `${ele.full_name[0]}, `
                } else {
                  item.company += ele.full_name[0]
                }
              });
            }
            newsTypeLists[this.locale].forEach(el => {
              if (el.children) {
                el.children.forEach(val => {
                  if (val.value == item.class) {
                    item.color = el.color
                    item.tag = val.title
                  }
                })
              }
            });
          })
          this.newsList = data
          this.page.total = res.data.page.total
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    async handleSearch(value) {
      await this.getCompanyNameList(value)
    },
    companyChange (value, option) {
      this.oaid = option.data.attrs.data
      this.companyName = value
    },
    newsTypeChange (value) {
      this.newsType = value
    },
    dateChange (date, dateString) {
      this.date = dateString
    },
    handleSubmit () {
      this.page.pagenum = 1
      this.getData()
    },
    displayRender({ labels }) {
      return labels[labels.length - 1]
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.getData()
    },
    cardClick (val) {
      const { href } = this.$router.resolve({
        name: 'newsDetail',
        query: {
          news_id: val
        }
      })
      window.open(href, '_blank')
    }
  },
  watch: {
    follow_entity(){
      this.page.pagenum = 1
      this.getData()
    }
  }
}



// WEBPACK FOOTER //
// ./src/esg/js/esg_public_sentiment.js